/** Shown while the client's Google Ads capabilities load. Nothing else mounts. */
export function GoogleAdsCheckingState() {
  return (
    <p role="status" className="text-sm text-muted-foreground">
      Checking Google Ads…
    </p>
  );
}
